import React from 'react';
import PropTypes from 'prop-types';
import ConnectionsView from './ConnectionsView';
import { SFConnection, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';

export default class ConnectionsContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    const URL = `../api/starfish/success-network/connections`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(({connections}) => this.props.onConnectionsFetched(connections))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return <ConnectionsView hasFetched={this.state.hasFetched} connections={this.props.connections} />;
  }
}

ConnectionsContainer.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.shape(SFConnection)).isRequired,
  onConnectionsFetched: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired
};
